import React from "react";
import { Link } from "react-router-dom";
import "../css/main.scss";

function Main() {
  const categories = [{ id: 1, name: "Gifts", active: true }];

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="main">
      <main>
        {/* Section 1 - Hero Slider */}
        <section className="hero-section">
          <div className="hero-slider">
            <div className="hero-slide">
              <div className="slide-content">
                <div className="slide-image-container">
                  <div className="sharing-badge">
                    <span className="heart">❤️</span>
                    <span>
                      Sharing
                      <br />
                      what we
                      <br />
                      love
                    </span>
                  </div>
                  <img
                    src="/img/dilverbloom-products/product-23.jpg"
                    alt="Dilverbloom espresso gift set"
                    className="hero-image"
                  />
                </div>
                <div className="slide-text">
                  <h1>Gifts Made to Savor</h1>
                  <p>Shop Now, Ship Later</p>
                  <Link to="/shop" onClick={toTop} className="hero-btn">
                    Shop Our Gifts
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Section 2 - Shop Favorites */}
        <section className="favorites-section">
          <div className="favorites-header">
            <h3>SHOP OUR FAVORITES</h3>
            <img
              src="/head/curb.svg"
              alt="Decorative"
              className="decorative-line"
            />
          </div>
          <div className="favorites-content">
            <div className="category-nav">
              {categories.map((cat) => (
                <button
                  key={cat.id}
                  className={`category-btn ${cat.active ? "active" : ""}`}
                >
                  {cat.name}
                </button>
              ))}
            </div>
            <div className="category-images">
              <div className="category-card">
                <img src="/img/dilverbloom-products/product-19.jpg" alt="Pistachio truffle gift" />
              </div>
              <div className="category-card">
                <img src="/img/dilverbloom-products/product-20.jpg" alt="Lemon meringue truffle gift" />
              </div>
              <div className="category-card">
                <img src="/img/dilverbloom-products/product-23.jpg" alt="Espresso gift box" />
              </div>
            </div>
          </div>
        </section>

        {/* Section 3 - Producers & Regions */}
        <section className="producers-section">
          <div className="producers-content">
            <div className="producers-text">
              <h2>Discover our Producers & Regions</h2>
              <p>
                Fire up your taste buds! It's time to meet the people behind the
                products and learn about the diverse regions across Italy. Let's
                do this!
              </p>
            </div>
            <div className="producers-images">
              <img src="/main/main3-1.svg" alt="Icon 1" />
              <img src="/img/dilverbloom-products/product-01.jpg" alt="Dilverbloom pizza flour" />
              <img src="/main/main3-3.svg" alt="Icon 2" />
              <img src="/img/dilverbloom-products/product-08.jpg" alt="Dilverbloom Sicilian marzipan" />
              <img src="/main/main3-5.svg" alt="Icon 3" />
              <img src="/img/dilverbloom-products/product-22.jpg" alt="Dilverbloom whole bean espresso" />
            </div>
          </div>
        </section>

        {/* Section 4 - Gourmet Gifts Banner */}
        <section className="gourmet-section">
          <div className="gourmet-banner">
            <img src="/img/dilverbloom-products/product-23.jpg" alt="Dilverbloom gourmet espresso gift" />
            <div className="gourmet-overlay">
              <p>SHARE THE GOOD STUFF</p>
              <h2>Italian gourmet gifts for any occasion!</h2>
              <div className="gourmet-buttons">
                <Link to="/shop" onClick={toTop} className="gourmet-btn">
                  Browse Our Gifts
                </Link>
              </div>
            </div>
          </div>
        </section>

        {/* Section 5 - Discovery Box */}
        <section className="discovery-section">
          <div className="discovery-content">
            <div className="discovery-images">
              <img src="/img/dilverbloom-products/product-17.jpg" alt="Dilverbloom Italian biscuit selection" />
            </div>
            <div className="discovery-text">
              <h2>$65 Every Two Months... Delivery Included!</h2>
              <p>
                Subscribe and be delighted every two months with a curated
                selection of Italian specialties. Treat yourself or share with
                someone you love!
              </p>
              <Link to="/about" onClick={toTop} className="discovery-btn">
                Learn More
              </Link>
            </div>
          </div>
        </section>

        {/* Section 6 - Collection */}
        <section className="collection-section">
          <img src="/img/dilverbloom-products/product-05.jpg" alt="Dilverbloom professional flour collection" />
        </section>

        {/* Section 7 - Products */}
        <section className="products-section">
          <div className="products-grid">
            <div className="product-card">
              <img src="/img/dilverbloom-products/product-10.jpg" alt="Traditional tarallini" />
            </div>
            <div className="product-card">
              <img src="/img/dilverbloom-products/product-18.jpg" alt="Rosemary focaccia bites" />
            </div>
            <div className="product-card">
              <img src="/img/dilverbloom-products/product-20.jpg" alt="Lemon meringue truffles" />
            </div>
          </div>
        </section>

        {/* Section 8 - Final Banner */}
        <section className="final-section">
          <div className="final-banner">
            <div className="banner-image">
              <img src="/img/dilverbloom-products/product-11.jpg" alt="Onion tarallini" />
              <img src="/img/dilverbloom-products/product-12.jpg" alt="Waffle-cut potato chips" />
              <img src="/img/dilverbloom-products/product-13.jpg" alt="Bruschette crackers" />
              <img src="/img/dilverbloom-products/product-14.jpg" alt="Semola grissini" />
              <img src="/img/dilverbloom-products/product-15.jpg" alt="Handmade grissini" />
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}

export default Main;
